import axios from 'axios';
import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
// import { useUserAuth } from '../../Context/userAuthContext';

const CompanyInfo = () => {
    const [company, setCompany] = useState({});
    const { id } = useParams();

    useEffect(() => {
        const fetchCompany = async () => {
            try {
                const response = await axios.get(`https://kariyer.biyomed.net/api/users/companyinfo/${id}`, {
                    withCredentials: true, // Cookie gönderimi için
                });
                setCompany({ ...response.data.company })
            } catch (error) {
                console.error("Error fetching user:", error);
            }
        };

        fetchCompany();
    }, []);

    return (
        <div className="jp_cp_profile_main_wrapper">
            <div className="container">
                <div className="row">
                    <div className="col-lg-4 col-md-4 col-sm-12 col-xs-12">
                        <div className="jp_cp_left_side_wrapper">
                            <div className="jp_cp_left_pro_wallpaper">
                                <img src={company.profile_image ? company.profile_image : "https://cdn.pixabay.com/photo/2015/10/05/22/37/blank-profile-picture-973460_1280.png"} alt="profile_img" />
                                <ul style={{ marginTop: 10 }}>
                                    {company.profile_link ? <li>
                                        <a href={company.profile_link && !company.profile_link.startsWith('https://') ? `https://${company.profile_link}` : company.profile_link}>
                                            {company.profile_link ? <i className="fa fa-globe" /> : ""}
                                        </a>
                                    </li> : ''}
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-8 col-md-8 col-sm-12 col-xs-12">
                        <div className="jp_cp_right_side_wrapper">
                            <div className="jp_cp_right_side_inner_wrapper">
                                <h2>Firma/Sağlık Kuruluşu Bİlgİlerİ</h2>
                                <table>
                                    <tbody>
                                        <tr>
                                            <td className="td-w25">Firma/Sağlık Kuruluşu Adı</td>
                                            <td className="td-w10">:</td>
                                            <td className="td-w65">{company?.company_name}</td>
                                        </tr>
                                        <tr>
                                            <td className="td-w25">Firma/Sağlık Kuruluşu Hakkında</td>
                                            <td className="td-w10">:</td>
                                            <td className="td-w65">{company?.about_company}</td>
                                        </tr>
                                        <tr>
                                            <td className="td-w25">Web Sayfası</td>
                                            <td className="td-w10">:</td>
                                            <td className="td-w65">
                                                <a
                                                    href={company?.website?.startsWith("http") ? company.website : `https://${company.website}`}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                >
                                                    {company?.website}
                                                </a>
                                            </td>

                                        </tr>
                                        <tr>
                                            <td className="td-w25">İl</td>
                                            <td className="td-w10">:</td>
                                            <td className="td-w65">{company?.city}</td>
                                        </tr>
                                        <tr>
                                            <td className="td-w25">Telefon</td>
                                            <td className="td-w10">:</td>
                                            <td className="td-w65">{company?.phone}</td>
                                        </tr>
                                        <tr>
                                            <td className="td-w25">Adres</td>
                                            <td className="td-w10">:</td>
                                            <td className="td-w65">
                                                {company?.company_address}
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    );
};

export default CompanyInfo;
